<template>
	<v-container fluid>
		<v-row>
			<v-col>
				<span class="headline">
					Ведомости мини-макс
				</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="pa-0">
				<a-data-table
					ref="table"
					v-model="selected"
					:headers="computedHeaders"
					api-path="mm/get_list"
					:api-parameters="{
						showAll: showAll
					}"
					disable-sort
					:show-select="showSelect"
					:single-select="false"
					:row-cursor-pointer="!showSelect"
					:initial="{
						search: $route.params.search,
						filters: $route.params.filters
					}"
					@click:row="clickRow"
					@load="onLoad"
					class="pt-2 pb-5"
				>
					<template v-slot:search-append-right>
						<v-menu
							v-model="dropdownMenu"
							:close-on-content-click="false"
							bottom left
						>
							<template v-slot:activator="{ on }">
								<v-btn
									icon
									v-on="on"
									class="mt-1 ml-2"
								>
									<v-icon>more_vert</v-icon>
								</v-btn>
							</template>

							<v-list class="d-print-none">
								<v-list-item @click="newMm">
									<v-list-item-icon>
										<v-icon>add</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Новая ведомость
									</v-list-item-title>
								</v-list-item>
								<v-list-item v-if="!showSelect" @click="unhideSelect">
									<v-list-item-icon>
										<v-icon style="transform: rotate(90deg)">call_merge</v-icon>
									</v-list-item-icon>
									<v-list-item-title>
										Соединить ведомости
									</v-list-item-title>
								</v-list-item>
								<v-list-item>
									<v-switch
										v-model="showAll"
										dense
									>
										<template v-slot:label>
											<span class="pl-2">
												Показать все
											</span>
										</template>
									</v-switch>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>

					<template v-slot:item.id="{ item }">
						<v-chip
							small
							label
							color="primary"
							:to="{ name: 'MmEntry', params: { id : item.id } }"
						>
							<v-icon small left>list_alt</v-icon>
							{{ item.id }}
						</v-chip>
					</template>
					<template v-slot:item.updatedDate="{ item }">
						{{ item.updatedDateFormatted }}
					</template>
					<template v-slot:item.status="{ item }">
						<v-tooltip left open-delay="500" v-if="item.statusName !== item.statusNameShort">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									{{ item.statusNameShort }}
								</span>
							</template>
							{{ item.statusName }}
						</v-tooltip>
						<span v-else>
							{{ item.statusName }}
						</span>
					</template>
					<template v-slot:item.stamps="{ item }">
						<div class="text-no-wrap">
							<v-chip
								small label link
								v-if="item.stamps.approved"
								color="blue"
								text-color="white"
								class="mr-1 mt-1"
							>
								Согласован
							</v-chip>

							<v-chip
								small label link
								v-if="item.newComments"
								color="blue-grey"
								text-color="white"
								class="mr-1 mt-1"
								@click="checkNewComments(item)"
							>
								...
							</v-chip>
						</div>
					</template>

				</a-data-table>
			</v-col>
		</v-row>
		<v-row v-if="showSelect">
			<v-col>
				<v-btn
					v-intersect="intersectButtons"
					color="primary"
					class="ma-2"
					:disabled="selected.length < 2"
					:loading="mergeLoading"
					@click="confirmMerge"
				>
					Соединить
				</v-btn>
				<v-btn
					v-intersect="intersectButtons"
					color="secondary"
					class="ma-2"
					@click="showSelect = false"
				>
					Отмена
				</v-btn>
			</v-col>
		</v-row>
		<div
			v-if="showSelect && !intersectingButtons"
			class="pa-0 d-print-none"
			style="position: fixed; bottom: 0px;"
		>
			<v-btn
				color="primary"
				class="ma-2"
				:disabled="selected.length < 2"
				@click="confirmMerge"
			>
				Соединить
			</v-btn>
			<v-btn
				color="secondary"
				class="ma-2"
				@click="showSelect = false"
			>
				Отмена
			</v-btn>
		</div>
	</v-container>
</template>

<script>
import aDataTable from '../base/ADataTable.vue'
import {api} from '../../lib/api'
import _ from 'lodash'

export default {
	mixins: [
	],
	components: {
		aDataTable
	},
	data: () => ({
		dropdownMenu: false,
		headers: [
			{
				text: '№',
				value: 'id',
				align: 'center',
				filterable: true,
				filterType: 'number',
			},
			{
				text: 'Дата',
				value: 'updatedDate',
				align: 'center',
				filterable: true,
				filterType: 'date',
			},
			{
				text: 'Отель',
				value: 'hotelCode',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Отдел',
				value: 'dcName',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Этап',
				value: 'status',
				align: 'center',
				filterable: true,
				filterType: 'select',
			},
			{
				text: 'Отметки',
				value: 'stamps',
				align: 'center',
				filterable: false,
			}
		],
		intersectingButtons: false,
		selected: [],
		showAll: false,
		showSelect: false,
		mergeLoading: false,
		timer: 0,
		scroll: false,
		updateInterval: 300000,	// 5 минут
	}),
	computed: {
		computedHeaders() {
			if (this.$vuetify.breakpoint.xsOnly) {
				return this.headers.filter(h => {
					return h.value == 'dcName'
						|| h.value == 'updatedDate'
				})
			}
			else {
				return this.headers
			}
		}
	},
	methods: {
		intersectButtons(entries, observer) {
			this.intersectingButtons = entries[0].isIntersecting
		},
		checkNewComments(row) {
			this.scroll = true
			this.clickRow(row)
		},
		clickRow(row) {
			if (!this.showSelect) {
				this.$router.push({
					name: 'MmEntry',
					params: {
						id: row.id,
						filters: this.$refs.table.filters,
						search: this.$refs.table.search,
						showAll: this.showAll,
						scroll: this.scroll
					}
				})
			}
		},
		confirmMerge() {
			let dcs = this.selected.map(item => item.dcName)
			dcs = Array.from(new Set(dcs))
			let hotelCodes = this.selected.map(item => item.hotelCode)
			hotelCodes = Array.from(new Set(hotelCodes))
			let statuses = this.selected.map(item => item.statusNameShort)
			statuses = Array.from(new Set(statuses))

			if (dcs.length > 1) {
				this.$store.dispatch('dialogNotify', {
					title: 'Разные отделы',
					message: 'Вы выбрали ведомости по разным отделам:<br><br>'
						+ dcs.join(',<br>')
						+ '<br><br>Соединить можно только ведомости по одному и тому же отделу. Сначала поменяйте отдел.'
				})
			}
			else if (hotelCodes.length > 1) {
				this.$store.dispatch('dialogNotify', {
					title: 'Разные отели',
					message: 'Вы выбрали ведомости по разным отелям:<br><br>'
						+ hotelCodes.join(',<br>')
						+ '<br><br>Соединить можно только ведомости по одному и тому же отелю.'
				})
			}
			else if (statuses.length > 1) {
				this.$store.dispatch('dialogNotify', {
					title: 'Разные статусы',
					message: 'Вы выбрали ведомости с разными статусами:<br><br>'
						+ statuses.join(',<br>')
						+ '<br><br>Соединить можно только ведомости в одном и том же статусе. Сначала поменяйте статус.'
				})
			}
			else {
				this.merge()
			}
		},
		merge() {
			this.mergeLoading = true

			let ids = this.selected.map(item => item.id)

			api.post('mm/merge', {
				ids: ids
			})
			.then(response => {
				this.$store.dispatch('dialogNotify', {
					title: 'Ведомости соединены',
					message: 'Ведомости '
						+ ids.join(', ')
						+ ' соединены в одну '
						+ `<router-link :to="{ name: 'MmEntry', params: { id: ${response.data.id} } }">`
						+ `${response.data.id}`
						+ '</router-link>'
				})

				this.mergeLoading = false
				this.showSelect = false
				this.selected = []
				this.$refs.table.clearAndLoad()
			}, error => {
				this.mergeLoading = false
			})
		},
		newMm() {
			this.$router.push('mm/new')
		},
		unhideSelect() {
			this.showSelect = true
			this.dropdownMenu = false
			this.selected = []
		},
		onLoad() {
			this.selected = []
			this.$store.dispatch('loadMenuCounters')
		},
	},
	created() {
		if (this.$route.params.showAll !== undefined) {
			this.showAll = this.$route.params.showAll
		}
	},
	mounted() {

		this.timer = setInterval(() => {
			// console.log('interval function')
			if (!document.hidden) {
				this.$refs.table.clearAndLoad()
			}
		}, this.updateInterval)

		// console.log(window.onfocus)

		window.onfocus = () => {
			// console.log('onfocus')
			this.$refs.table.clearAndLoad()
		}
	},
	destroyed() {
		clearInterval(this.timer)
		window.onfocus = null
	},
}
</script>

<style>
</style>
